import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import BodyClassName from 'react-body-classname'

import UserSettingsComponent from './userSettings.component'
import Loader from '../utils/loader.component'
import Header from '../header'
import './userSettings.scss'

const userSettingsContainer = (props) => {
  const { user, showPaywall } = props
  const { loading, data } = user
  if (loading) {
    return <Loader />
  }
  if (!data) {
    return <Redirect to="/login" />
  }
  return (
    <BodyClassName className="auth-style">
      <>
        <Header />
        <UserSettingsComponent
          user={data}
          showPaywall={showPaywall}
        />
      </>
    </BodyClassName>
  )
}

const mapStateToProps = state => ({
  user: state.user,
})


export default connect(
  mapStateToProps,
)(userSettingsContainer)
